import {
  FIRM_SUMMARY_SPREADSHEET_NAME,
  FIRM_SUMMARY_SPREADSHEET_TITLE,
  FIRM_SUMMARY_SPREADSHEET_TITLE_ALIAS,
  FIRM_SUMMARY_SPREADSHEET_TOTAL_ALIAS,
  FIRM_SUMMARY_TOTAL_TITLE,
} from 'pages/Firms/common/constants';
import { CreateRowsParams, CreateRowsReturn, FirmSummaryRow } from './createRows.types';
import { createFundRows } from './utils';

const createRows = (params: CreateRowsParams): CreateRowsReturn => {
  const { firmSlug, fundsByCompany, isAllFundsSelected, groupBy } = params;

  return [
    {
      alias: FIRM_SUMMARY_SPREADSHEET_TITLE_ALIAS,
      className: `${FIRM_SUMMARY_SPREADSHEET_NAME}__title division-bottom-only`,
      gridType: 'string',
      largeHeader: true,
      readOnly: true,
      value: FIRM_SUMMARY_SPREADSHEET_TITLE,
    } as FirmSummaryRow,
    ...createFundRows({ firmSlug, fundsByCompany, isAllFundsSelected, groupBy }),
    {
      alias: FIRM_SUMMARY_SPREADSHEET_TOTAL_ALIAS,
      className: `${FIRM_SUMMARY_SPREADSHEET_NAME}__total division`,
      format: null,
      gridType: 'string',
      readOnly: true,
      value: FIRM_SUMMARY_TOTAL_TITLE,
    } as FirmSummaryRow,
  ];
};

export default createRows;
